import React, { useEffect, useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Select, Input} from "@nextui-org/react";
import axios from "axios";
import { orders_uri } from "../../../../utils/url";
import { toast } from "react-toastify";
import { GET } from "../../../../utils/requests";
import { TYPES } from "../../../../utils/types";
import Paginations from "../../../../components/Pagination";
import DeclineModal from "./decline";
import DeleteModal from "./delete";
import UpdateModal from "./update";

export default function OrderDetailModal({prod, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({limit:10, all:'', totalPage:''});
  const [load, setLoad] = useState(false);
  const [subload, setSubload] = useState(false);
  const [data, setData] = useState([]);
  const [prodcode, setProdcode] = useState('all');
  const [pay, setPay] = useState('');

  const call = () =>{
    callback();
  }

  const Get = async (e) => {
    setLoad(true);
    const b = await GET(orders_uri+`/prod-orders?page=${page}&limit=${pagination.limit}&type=${TYPES.REQUESTED}&id=${prod.id}&code=${e}`);
    setData(b.data.data);
    setPagination({...pagination, all:b.data.all, totalPage:b.data.totalPage});
    setLoad(false);
  };

  const Sub = async () => {
    if(pay === '') return toast.error("Карго төлбөр оруулна уу !");
    if(data.length === 0) return toast.error("Уучлаарай энэ сонголтонд баталгаажуулах бараа байхгүй байна !");
    setSubload(true);
    try{
        const res = await axios.patch(orders_uri+'/pay', {code: prodcode, pay:pay, id:prod.id});
        if(res.status === 200){
            toast.success("Амжилттай");
            setPay('');
            setSubload(false);
            Get();
        }
    }catch(err){
        console.log(err);
        setSubload(false);
    }
  }

  const changePage = (page) => {
    setPage(page);
  };

  const On = () =>{
    onOpen();
    Get();
  }

  const prodset = (e) => {
    setProdcode(e)
    Get(e);
  }

  const call1 = () =>{
    Get();
  }

  useEffect(() => {
    if (isOpen) {
      Get();
    }
  }, [page]);

  return (
    <>
      <Button size='sm' onPress={On} className="ml-2">Захиалгын дэлгэрэнгүй</Button>
      <Modal size="2xl" isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior="inside">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1"> '( {prod.name} )' барааны захиалгын мэдээлэл</ModalHeader>
              <ModalBody>
                <div>
                  <div>
                    <select className="bg-gray-100 rounded-md p-1 mb-4 w-full" onChange={(e)=> prodset(e.target.value)}>
                      <option value='all'>Бүгд</option>
                      {
                        prod.product_code.map((it, index) => {
                          return(
                            <option value={it.code} key={index}>{it.code}</option>
                          )
                        })
                      }
                    </select>
                    <div className="flex items-center gap-2  mb-4">
                      <input value={pay} onChange={(e)=> setPay(e.target.value)} type="number" placeholder="Каргоны төлбөр" size="sm" className="ring-1 outline-none rounded-md p-1 px-2 w-full"/>
                      {
                        subload?
                        <Button size="sm">
                          Уншиж байна ...
                        </Button>
                        :
                        <Button size="sm" onClick={Sub}>
                          Баталгаажуулах
                        </Button>
                      }
                    </div>
                  </div>
                      <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                        <thead className="bg-gray-50 dark:bg-gray-700">
                          <tr>
                            <th scope="col" className="p-4 text-sm font-normal">
                              No
                            </th>
                            <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Утасны дугаар/дансны дугаар
                            </th>
                            <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Ширхэг
                            </th>
                            <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              Код
                            </th>
                            <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                              
                            </th>
                          </tr>
                        </thead>
                        {
                          load?
                          <div className='flex items-center justify-center  p-4'>
                            <Spinner/>
                            <h1 className=''>Уншиж байна ...</h1>
                          </div>
                          :
                          <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                            {
                              data.map((item, index) => {
                                return(
                                  <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                                      <td className="p-2 w-4 text-center">
                                        {index+1}
                                      </td>
                                      <td className="py-2 px-6 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white flex flex-col">
                                        <label className=''>{item.phone_or_depo}</label>
                                      </td>
                                      <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.too}</td>
                                      <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">{item.code}</td>
                                      <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow flex gap-1">
                                        <DeclineModal data={item.id} callback={call1}/>
                                        <DeleteModal data={item.id} callback={call1}/>
                                        <UpdateModal data={item} callback={call1} prod={prod}/>
                                      </td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        }
                      </table>
                      {
                        data.length === 0 &&
                        <div className='bg-white pt-8 text-center flex items-center justify-center flex-col'>
                          <img className='h-24' src='../../empty.gif'/>
                          <h1 className=''>Хоосон байна...</h1>
                        </div>
                      }
                      <Paginations initialPage={page} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {/* {
                    load?
                    <Button className="bg-blue-300">
                        Баталгаажуулж байна ...
                    </Button>
                    :
                    <Button color="primary" onPress={Sub}>
                        Тийм
                    </Button>
                } */}
              </ModalFooter>
            </>
          )}
        </ModalContent>
        {
          (onClose) => setPay('')
        }
      </Modal>
    </>
  );
}
